import { ColorEnum } from '@/constants/color'
import {
    defaultInteractiveBackgroundColors,
    mainColors,
    outlineInteractiveBackgroundColors,
    shadowColors,
} from '@/features/ui/buttons/components/IconButton/constants'
import { Color, Type } from '@/features/ui/buttons/components/IconButton/types'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { isInteractiveButtonState } from '@/features/ui/buttons/utils'

export const getMainColor = (state: ButtonStateEnum, color: Color) => mainColors[state][color]

export const getBackgroundColor = (type: Type, state: ButtonStateEnum, color: Color) => {
    if (state === ButtonStateEnum.Disabled) return ColorEnum.Transparent

    if (type === 'default') {
        if (isInteractiveButtonState(state)) return defaultInteractiveBackgroundColors[color]

        return ColorEnum.Transparent
    }

    if (type === 'filled') return getMainColor(state, color)

    if (type === 'outline') {
        if (isInteractiveButtonState(state)) return outlineInteractiveBackgroundColors[color]

        return ColorEnum.Transparent
    }
}

export const getElementColor = (type: Type, state: ButtonStateEnum, color: Color) => {
    if (type === 'default') return getMainColor(state, color)

    if (state === ButtonStateEnum.Disabled) return ColorEnum.GRAY_400

    if (type === 'filled') return ColorEnum.WHITE

    if (type === 'outline') return getMainColor(state, color)
}

export const getOutlineBorder = (state: ButtonStateEnum, color: Color) => ({
    borderColor: getElementColor('outline', state, color),
    borderWidth: 2,
})

export const getShadows = (color: Color) => ({
    boxShadow: `0px 0px 4px ${shadowColors[color]}`,
    elevation: 4,
    shadowColor: shadowColors[color],
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 4,
    shadowOpacity: 1,
})
